import Popup from '@/components/popup'
import React from 'react'
import { useTranslation } from 'react-i18next'

const TermsAndConditions = ({ modalID }) => {
  const { t } = useTranslation()

  return (
    <Popup needbtn={false} name="terms-and-conditions" title=" " modalID={modalID}>
      <div className="terms-and-conditions-content">
        <h3>{t('terms-and-conditions')}</h3>

        <p>{t('broker-terms-intro')}</p>

        <h4>{t('broker-terms-data-title')}</h4>
        <ul>
          <li>{t('broker-terms-data-1')}</li>
          <li>{t('broker-terms-data-2')}</li>
          <li>{t('broker-terms-data-3')}</li>
        </ul>

        <h4>{t('broker-terms-referral-title')}</h4>
        <ul>
          <li>{t('broker-terms-referral-1')}</li>
          <li>{t('broker-terms-referral-2')}</li>
          <li>{t('broker-terms-referral-3')}</li>
        </ul>
      </div>
    </Popup>
  )
}

export default TermsAndConditions